import React from 'react';
import BottomNav from '../components/BottomNav';

const WellnessRetreats = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Wellness Retreats</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Rejuvenate Body & Mind</p>
        
        <div className="card">
          <p>
            Experience transformative wellness retreats at the world's most exclusive destinations. 
            Holistic programs designed for complete rejuvenation and wellbeing.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Premier Destinations</h3>
              <p>Luxury wellness resorts in stunning locations</p>
            </div>
            <div className="feature-item">
              <h3>Personalized Programs</h3>
              <p>Customized wellness journeys tailored to your needs</p>
            </div>
            <div className="feature-item">
              <h3>Expert Practitioners</h3>
              <p>World-class therapists and wellness specialists</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default WellnessRetreats;
